<label class="form-label ms-2" [for]="id">{{ fieldDefinition.label }}</label>
<div
  *ngIf="inputDisabled"
  class="wysiwyg-editor ms-3"
  [innerHTML]="initialValue"></div>
<div *ngIf="!inputDisabled" class="form-group rounded mx-1">
  <app-ck-editor
    #editor
    [initialData]="initialValue || ''"
    [disabled]="inputDisabled"
    (contentChange)="this.value.emit($event)"
    [version]="'full'"></app-ck-editor>
</div>
